import { render } from "./ComplianceEmpresarialView.vue?vue&type=template&id=4605dd18&scoped=true"
import script from "./ComplianceEmpresarialView.vue?vue&type=script&lang=js"
export * from "./ComplianceEmpresarialView.vue?vue&type=script&lang=js"

import "./ComplianceEmpresarialView.vue?vue&type=style&index=0&id=4605dd18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4605dd18"]])

export default __exports__